import {useCallback} from 'react';
import {useHistory} from 'react-router-dom';

export function useGoBackHook(fallbackUrl: string): VoidFunction {
    const history = useHistory();

    return useCallback(() => {
        if (history.length > 1) {
            history.goBack();
        } else {
            history.replace(fallbackUrl);
        }
    }, [history, fallbackUrl]);
}
